
























import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  components:{}
})
export default class ProductPicker extends Vue{
  @Prop() value!: any

  items=[];

  mounted(){
    Vue.prototype.$http.request({
      method:"POST",
      responseType:"json",
      data:JSON.stringify([]),
      transformRequest:[function (data:any, headers:any) {
        return data;
      }],
      url:"productSearch?page=1&limit=50"
    }).then((res:any)=>{
      this.items=res.data.data;
    });
  }

  input(value:any){
    this.$emit('product-id', value.product_id);
    this.$emit('input', value);
  }
}
